import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export function FAQAccordion({ items = [], testIdPrefix = "faq" }) {
  return (
    <Accordion type="single" collapsible className="w-full space-y-3">
      {items.map((item, i) => (
        <AccordionItem
          key={i}
          value={`item-${i}`}
          data-testid={`${testIdPrefix}-item-${i}`}
          className="rounded-xl border border-nm-border bg-nm-surface px-4 sm:px-5"
        >
          <AccordionTrigger className="py-4 text-left text-sm font-semibold text-nm-text hover:no-underline sm:text-base">
            {item.q}
          </AccordionTrigger>
          <AccordionContent className="pb-4 text-sm text-nm-muted leading-relaxed">
            {item.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
